import React, { useEffect, useState, useCallback, useMemo } from "react";
import { AppListing } from "../../components/appListing";
import { telemedicinesApi } from "../../redux/service/telemedicine_service";
import { toast } from "react-toastify";
import ethizo_active_icon from "../../assests/icons/ethizo_active.svg";
import ethizo_inactive_icon from "../../assests/icons/ethizo_inactive.svg";

function Telemedicines() {
  const [telemedicinesListingTrigger] =
    telemedicinesApi.endpoints.getTelemedicines.useLazyQuery();
  const [loading, setLoading] = useState(false);
  const [telemedicines, setTelemedicines] = useState([]);

  const handleVizoCall = useCallback((item) => {
    const callUrl = item.visit_url;
    window.open(callUrl, "_blank");
  }, []);

  const fetchTelemedicines = useCallback(async () => {
    setLoading(true);
    try {
      const response = await telemedicinesListingTrigger({
        vezo_id: "",
        status: "scheduled,in-progress,on-hold",
      });
      if (response?.data?.data) {
        setTelemedicines(response.data.data);
      } else {
        setTelemedicines([]);
      }
    } catch (error) {
      console.error("Error fetching telemedicines", error);
      toast.error("Error fetching telemedicines");
      setTelemedicines([]);
    } finally {
      setLoading(false);
    }
  }, [telemedicinesListingTrigger]);

  useEffect(() => {
    fetchTelemedicines();
  }, [fetchTelemedicines]);

  const columns = useMemo(
    () => [
      { title: "Title", key: "title" },
      { title: "Status", key: "status" },
      { title: "Created By", key: "user_name" },
      {
        title: "Join Call",
        key: "is_expired",
        getData: (item) => (
          <div>
            {!item.is_expired ? (
              <div
                className="cursor-pointer"
                role="button"
                tabIndex={0}
                onClick={() => handleVizoCall(item)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleVizoCall(item);
                  }
                }}
              >
                <img src={ethizo_active_icon} alt="Join Call" />
              </div>
            ) : (
              <div className="cursor-not-allowed">
                <img src={ethizo_inactive_icon} alt="Call Inactive" />
              </div>
            )}
          </div>
        ),
      },
    ],
    [handleVizoCall]
  );

  return (
    <>
      <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
        <div className="flex gap-5 items-center">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Telemedicine
          </h3>
        </div>
        <div className="flex-shrink-0">
          <button
            type="button"
            onClick={fetchTelemedicines}
            className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Reload
          </button>
        </div>
      </div>
      <div className="flex-auto bg-white justify-start p-3 text-start">
        <AppListing loading={loading} listData={telemedicines} cols={columns} />
      </div>
    </>
  );
}

export default React.memo(Telemedicines);
